import { Decodable } from './_decodable';
import { Accompaniment } from './accompaniment';
import { AnaliseCriticaLog } from './analise-critica-log';
import { Client } from './client';
import { Contract } from './contract';
import { Cycle } from './cycle';
import { Director } from './director';

class AnaliseCritica extends Decodable {

    id: number
    clienteId: number
    cycleId?: number
    contractId?: number
    status: number
    uuid: string
    cliente: Client
    cycle: Cycle
    contract?: Contract
    accompaniments: Accompaniment[]
    logs: AnaliseCriticaLog[]

    comercial?: AnaliseCriticaLog
    pesquisa?: AnaliseCriticaLog
    administrativa?: AnaliseCriticaLog
    executiva?: AnaliseCriticaLog

    updatedAt: Date
    createdAt: Date

    statusCodes = {
        'pending': 1,
        'approved': 2,
        'reproved': 3,
        'finished': 4,
        'criada': 5,
    }

    get statusColor(): string {
        if (this.status === this.statusCodes.pending) {
            return '#F59E0B'; // amber
        } else if (this.status === this.statusCodes.approved) {
            return '#10B981'; // emerald
        } else if (this.status === this.statusCodes.reproved) {
            return '#EF4444'; // soft red
        } else if (this.status === this.statusCodes.finished) {
            return '#3B82F6'; // soft blue
        } else if (this.status === this.statusCodes.criada) {
            return '#9CA3AF'; // soft gray
        }

        return ''
    }

    get statusText(): string {
        if (this.status === this.statusCodes.pending) {
            return 'Pendente'
        } else if (this.status === this.statusCodes.approved) {
            return 'Aprovada'
        } else if (this.status === this.statusCodes.reproved) {
            return 'Reprovada'
        } else if (this.status === this.statusCodes.finished) {
            return 'Finalizada'
        } else if (this.status === this.statusCodes.criada) {
            return 'Criada'
        }

        return ''
    }


    protected _map = {
        updatedAt: e => this.parseDate(e),
        createdAt: e => this.parseDate(e),
        cliente: e => Client.parse(e),
        cycle: e => Cycle.parse(e),
        contract: e => Contract.parse(e),
        accompaniments: e => Accompaniment.parse(e),
        logs: e => AnaliseCriticaLog.parse(e),
        comercial: e => AnaliseCriticaLog.parse(e),
        pesquisa: e => AnaliseCriticaLog.parse(e),
        administrativa: e => AnaliseCriticaLog.parse(e),
        executiva: e => AnaliseCriticaLog.parse(e),
    }
}

export {
    AnaliseCritica
}